import { useEffect } from 'react';

interface UseClickOutsideProps {
  refs: React.RefObject<Node>[];
  onClickOutside: () => void;
}

const useClickOutside = ({ refs, onClickOutside }: UseClickOutsideProps) => {
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (
        refs.every(
          (ref) => ref.current && !ref.current.contains(event.target as Node)
        )
      ) {
        onClickOutside();
      }
    };

    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [refs, onClickOutside]);
};

export default useClickOutside;
